import React, { useState, useEffect } from "react";
import { notificarError, notificarMsg } from "../Almacenes/AlmacenNotify";
import ProductFinder from "./ProductFinder";
import SalidaTable from "./SalidaTable";
import moment from "moment";
import { PRECIO_MENOR, TIPO_STOCK } from "../../Global";
import { fetchConfig as fetchConfigMovAlmacen } from "./Ticket";

export default function EditarSalida({ idMovimiento, onActualizacionCompletada, onClose }) {
    const [proveedor, setProveedor] = useState(null);
    const [items, setItems] = useState([]);
    const [linkedDocument, setLinkedDocument] = useState(null);
    const [loading, setLoading] = useState(true);
    const [datosMovimiento, setDatosMovimiento] = useState(null);
    const [tiposTransaccion, setTiposTransaccion] = useState([]);
    const [botonBloqueado, setBotonBloqueado] = useState(false);
    const [tiempoBloqueo, setTiempoBloqueo] = useState(null);
    const [sucursal, setSucursal] = useState({ Abastecimiento: false });
    const [confEmpresa, setConfEmpresa] = useState({
        movAlmacenJustPrecioVenta: false
    });
    const [configMovAlmacen, setConfigMovAlmacen] = useState({
        movAlmacenJustPrecioVenta: false,
        showSalePriceOnNotaEgreso: false
    })

    const bloquearBotonTemporalmente = () => {
        setBotonBloqueado(true);
        
        if (tiempoBloqueo) {
            clearTimeout(tiempoBloqueo);
        }
        
        const nuevoTimeout = setTimeout(() => {
            setBotonBloqueado(false);
            setTiempoBloqueo(null);
        }, 2000);
        
        setTiempoBloqueo(nuevoTimeout);
    };

    useEffect(() => {
        fetchConfEmpresa();
        fetchConfigMovAlmacen().then(conf => {
            setConfigMovAlmacen(conf);
        });
    }, []);

    useEffect(() => {
        return () => {
            if (tiempoBloqueo) {
                clearTimeout(tiempoBloqueo);
            }
        };
    }, [tiempoBloqueo]);


    useEffect(() => {
        if (idMovimiento) {
            cargarDatosMovimiento();
        }
    }, [idMovimiento]);


    useEffect(() => {
        if (datosMovimiento?.IdTipoDocumentoSunat) {
            cargarTiposTransaccion();
        }
    }, [datosMovimiento]);

    useEffect(() => {
        if (datosMovimiento && tiposTransaccion.length > 0) {
            procesarDatosCompletos();
        }
    }, [datosMovimiento, tiposTransaccion]);

    const fetchConfEmpresa = async () => {
        const req = await fetch(`/api/config/emp`);
        const conf = await req.json();

        if (!('movAlmacenJustPrecioVenta' in conf)) {
            conf['movAlmacenJustPrecioVenta'] = false;
        };

        if (!('showSalePriceOnNotaEgreso' in conf)) {
            conf['showSalePriceOnNotaEgreso'] = false;
        };

        setConfEmpresa(conf);
    }

    const cargarDatosMovimiento = async () => {
        try {
            setLoading(true);

            const response = await fetch(`/api/movimientosalmacen/item/${idMovimiento}`);

            if (!response.ok) {
                throw new Error('Error al cargar los datos del movimiento');
            }

            const responseData = await response.json();
            const data = Array.isArray(responseData) && responseData.length > 1 && Array.isArray(responseData[1]) && responseData[1].length > 0
                ? responseData[1][0]
                : {};

            if (data.IdProveedor) {
                const proveedorResponse = await fetch(`/api/proveedores/item/${data.IdProveedor}`);
                if (proveedorResponse.ok) {
                    const proveedorData = await proveedorResponse.json();
                    setProveedor(proveedorData[0][0]);
                }
            }

            if (data.NroDocumentoSunat) {
                const [serie, correlativo] = data.NroDocumentoSunat.split('-');
                setLinkedDocument({
                    serie: serie || '',
                    correlativo: correlativo || '',
                    tipoDoc: data.tipoDoc || '',
                    total: data.total || 0,
                    fechaMovimiento: data.FechaMovimiento,
                    fechaEmision: data.FechaMovimiento
                });
            }

            setDatosMovimiento(data);
        } catch (error) {
            console.error('Error al cargar datos:', error);
            notificarError('Error al cargar los datos del movimiento: ' + error.message);
            setLoading(false);
        }
    };

    const cargarTiposTransaccion = async () => {
        try {
            const tiposTransaccionData = await fetchTiposTransaccion();
            setTiposTransaccion(tiposTransaccionData);
        } catch (error) {
            console.error('Error al cargar tipos de transacción:', error);
            notificarError('Error al cargar los tipos de transacción: ' + error.message);
            setLoading(false);
        }
    };

    const procesarDatosCompletos = async () => {
        try {
            const sucursalData = await fetchSucursal();

            const itemsCargados = await loadItems(tiposTransaccion);

            if (itemsCargados.length === 0 && datosMovimiento.IdProveedor) {
                const productos = await loadProductosAsociados(datosMovimiento.IdProveedor);

                productos.filter(p => !!p).forEach(p => {
                    if (tiposTransaccion.length > 0) {
                        handleChooseProduct({
                            ...p,
                            Cantidad: 0,
                            idTipoTransaccion: tiposTransaccion[0].IdTipoTransaccionAlmacen,
                        }, sucursalData);
                    }
                });
            }

            setLoading(false);
        } catch (error) {
            console.error('Error al procesar datos completos:', error);
            notificarError('Error al procesar los datos: ' + error.message);
            setLoading(false);
        }
    };

    const fetchSucursal = async () => {
        const response = await fetch(`/api/configFactElectronica/SucursalEmpresa`);

        if (!response.ok) {
            return null;
        }

        const data = await response.json();

        const sucursalData = data.find(s => s.IdSucursal === datosMovimiento.IdAlmacen);

        setSucursal(sucursalData || { Abastecimiento: false });
        return sucursalData || { Abastecimiento: false };
    }

    const loadProductosAsociados = async (IdProveedor) => {
        const response = await fetch(`/api/movimientosalmacen/productos-asociados/${IdProveedor}`);

        if (!response.ok) {
            return [];
        }

        const productos = await response.json();

        return productos;
    }

    const loadItems = async (tiposTransaccionParam = null) => {
        const response = await fetch(`/api/movimientosalmacen/detallemovimiento/list/${idMovimiento}`);

        if (!response.ok) {
            setItems([]);
            return [];
        }

        const responseData = await response.json();
        const items = responseData[1];
        const detalles = [];

        const tiposTransaccionToUse = tiposTransaccionParam || tiposTransaccion;

        if (!tiposTransaccionToUse || tiposTransaccionToUse.length === 0) {
            console.warn('Tipos de transacción no disponibles al cargar items');
            return [];
        }

        const idsPrecioVentaNull = Array.from(new Set(
            items
                .filter(item => item.PrecioVenta == null)
                .map(item => item.IdPresentacion)
                .filter(id => id != null)
        ));

        const preciosVentaMap = await fetchPreciosVentaBulk(idsPrecioVentaNull);

        for (let i = 0; i < items.length; i++) {
            const x = items[i];

            if (x.PrecioVenta == null) {
                x.PrecioVenta = preciosVentaMap.get(x.IdPresentacion) ?? 0;
            }

            const codigosLote = await fetchCodigosLote(x.IdProducto);

            const codLote = (x.IdLoteMovAlmacen && x.IdLoteMovAlmacen !== 0 && x.IdLoteMovAlmacen !== '0') 
                ? x.IdLoteMovAlmacen 
                : (x.CodLote && x.CodLote !== 0 && x.CodLote !== '0') 
                    ? x.CodLote 
                    : null;
            
            if (x.Cantidad > 0 && !codLote) {
                console.log('Item sin CodLote detectado al cargar:', {
                    label: x.NomProducto,
                    Cantidad: x.Cantidad,
                    IdLoteMovAlmacen: x.IdLoteMovAlmacen,
                    CodLoteOriginal: x.CodLote,
                    IdDetalleMovimientosAlmacen: x.IdDetalleMovimientosAlmacen,
                    Correlativo: x.Correlativo
                });
            }

            const d = {
                ...x,
                label: x.NomProducto,
                CodigosLote: codigosLote || [],
                CodLote: codLote,
                IdStock: x.IdStock,
                precioCostoIgv: x.Precio,
                PrecioCosto: x.Precio,
                precioUnidadDolar: 0,
                precioUnidadDolarSinIgv: 0,
                idTipoTransaccion: tiposTransaccionToUse[0]?.IdTipoTransaccionAlmacen,
            }

            detalles.push(d);
        }

        setItems(detalles);

        return detalles;
    }

    const handleValueChange = (item, fieldName, newValue) => {
        console.log(`Cambio en ${fieldName}:`, { item, newValue });

        setItems(prevState => prevState.map(row =>
            row.IdPresentacion === item.IdPresentacion && row.idTipoTransaccion === item.idTipoTransaccion
                ? { ...row, [fieldName]: newValue }
                : row
        ));

        bloquearBotonTemporalmente();

        notificarMsg(`${fieldName} actualizado a ${newValue} para ${item.label}`);
    }

    const handleDelete = (item) => {
        const presentacion = item.IdPresentacion;
        const tipoTransaccion = item.idTipoTransaccion;
        const toDeleteIndex = items.findIndex(item => item.IdPresentacion == presentacion && item.idTipoTransaccion == tipoTransaccion);

        const newItems = [...items];
        newItems.splice(toDeleteIndex, 1);
        setItems(newItems);
    }

    const checkStockByIdPresentacion = async (IdPresentacion) => {
        const req = await fetch(`/api/presentaciones/${IdPresentacion}/stocks`);
        const data = await req.json();
        return data;
    }

    const fetchCodigosLote = async (IdProducto) => {
        const response = await fetch(`/api/movimientosalmacen/codigos-lote/${IdProducto}`);
        const data = await response.json();
        return data;
    }

    const handleChooseProduct = async (product, sucursalOverride = null) => {

        const codigosLote = Array.isArray(product.Lotes) ? product.Lotes : [];
        const sucursalData = sucursalOverride || sucursal;

        setItems(prevState => {
            const item = prevState.find(item => item.IdPresentacion === product.IdPresentacion);

            if (item) {
                notificarError("El producto ya ha sido seleccionado.");
                return prevState;
            }

            const defaultCodLote = codigosLote.length > 0 ? codigosLote[0].IdLote : null;

            const newItem = {
                ...product,
                Cantidad: 'Cantidad' in product ? product.Cantidad : 1,
                CodigosLote: codigosLote || [],
                CodLote: sucursalData?.Abastecimiento ? defaultCodLote : null,
            };

            return [...prevState, newItem];
        });

        bloquearBotonTemporalmente();
    }

    const fetchTiposTransaccion = async () => {
        if (!datosMovimiento?.IdTipoDocumentoSunat) {
            throw new Error('IdTipoDocumentoSunat no disponible');
        }

        const response = await fetch(`/api/movimientosalmacen/tipotransaccion/list/${datosMovimiento.IdTipoDocumentoSunat}?idTipoMovAlmacen=2`);
        
        if (!response.ok) {
            throw new Error('Error al cargar tipos de transacción');
        }

        const data = await response.json();
        return data[1];
    }

    const fetchPrecioVenta = async (IdPresentacion) => {
        const response = await fetch(`/api/presentaciones/precios/${IdPresentacion}`);

        if (!response.ok) {
            return 0;
        }

        const data = await response.json();
        const precios = data.respuesta;

        return precios.find(precio => precio.IdPrecioPlantilla === PRECIO_MENOR).PrecioIGV;
    }

    const fetchPreciosVentaBulk = async (ids) => {
        if (!ids || ids.length === 0) {
            return new Map();
        }

        const response = await fetch(`/api/presentaciones/precios/bulk`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ ids }),
        });

        if (!response.ok) {
            return new Map();
        }

        const data = await response.json();
        const precios = data.respuesta || [];
        const preciosMap = new Map();

        for (let i = 0; i < precios.length; i++) {
            const precio = precios[i];
            if (precio.IdPrecioPlantilla === PRECIO_MENOR && !preciosMap.has(precio.IdPresentacion)) {
                preciosMap.set(precio.IdPresentacion, precio.PrecioIGV);
            }
        }

        return preciosMap;
    }

    const deleteItem = async (item, showAlert = true) => {
        try {
            const response = await fetch(`/api/movimientosalmacen/detallemovimiento/delete/${item.IdDetalleMovimientosAlmacen}`, {
                method: 'DELETE',
            });

            if (!response.ok) {
                throw new Error('Error al eliminar el item');
            }

            if (showAlert) {
                notificarMsg(`Item ${item.label} eliminado correctamente`);
            }
        } catch (error) {
            console.error(error);

            if (showAlert) {
                notificarError(`Surgió un error al eliminar el item ${item.label}`);
            }
        }
    }

    const validarStock = async (item) => {
        if (sucursal.Abastecimiento) {
            return true;
        }

        const stocks = await checkStockByIdPresentacion(item.IdPresentacion);
        const stockConComprobante = stocks.find(stock => stock.IdTipoStock === TIPO_STOCK.CON_COMPROBANTE);
        const currentQuantity = stockConComprobante.Stock;
        const requestedQuantity = parseFloat(item.Cantidad);
        const remainingStock = currentQuantity - requestedQuantity;

        if (remainingStock < 0) {
            notificarError(`No hay stock disponible para el producto ${item.label}`);
            return false;
        }

        return true;
    }

    const saveItem = async (item) => {
        const precio = configMovAlmacen.showSalePriceOnNotaEgreso ? +item.PrecioMenorIGV : +item.precioCostoIgv;
        
        const req = await fetch('/api/movimientosalmacen/detallemovimiento/add/', {
            method: 'POST',
            body: JSON.stringify({
                IdDetalleMovimientosAlmacen: 1,
                Cantidad: item.Cantidad,
                FechaCaducidad: null,
                IdMovimientoAlmacen: idMovimiento,
                IdProducto: item.IdProducto,
                IdLote: null,
                IdPresentacion: item.IdPresentacion,
                IdUnidad: item.IdUnidad,
                IdStock: null,
                Precio: precio,
                PrecioVenta: precio,
                precioUnidadDolar: 0,
                precioUnidadDolarSinIgv: 0,
                Total: item.Cantidad * precio,
                idTipoTransaccion: item.idTipoTransaccion,
                Flete: 0,
                IdLoteMovAlmacen: item.CodLote,
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })

        if (!req.ok) {
            notificarError(`Surgió un error al registrar el item ${item.label}`);
        }

        notificarMsg(`Item ${item.label} registrado correctamente`);
    }

    const handleGuardarCambios = async () => {
        try {
            const itemsAreValidPromises = items.map(item => validarStock(item));
            const itemsValidos = await Promise.all(itemsAreValidPromises);

            if (itemsValidos.some(item => !item)) {
                return;
            }

            if (sucursal.Abastecimiento) {
                const itemsSinCodLote = items.filter(item => {
                    if (item.Cantidad <= 0) return false;
                    // Verificar que CodLote sea un valor válido (número mayor que 0)
                    const codLoteValido = item.CodLote && 
                                         item.CodLote !== 0 && 
                                         item.CodLote !== '0' && 
                                         item.CodLote !== null && 
                                         item.CodLote !== undefined &&
                                         item.CodLote !== '';
                    return !codLoteValido;
                });

                if (itemsSinCodLote.length > 0) {
                    const productosAfectados = itemsSinCodLote.map(item => item.label).join(', ');
                    notificarError(`El código de lote es requerido para los siguientes productos: ${productosAfectados}`);
                    return;
                }
                
                const itemsConStockInsuficiente = items.filter(item => {
                    if (item.Cantidad <= 0) return false;
                    
                    const loteSeleccionado = item.CodigosLote?.find(lote => lote.IdLote === item.CodLote);
                    if (!loteSeleccionado) return false;
                    
                    return item.Cantidad > loteSeleccionado.Cantidad;
                });

                if (itemsConStockInsuficiente.length > 0) {
                    const mensajesError = itemsConStockInsuficiente.map(item => {
                        const loteSeleccionado = item.CodigosLote.find(lote => lote.IdLote === item.CodLote);
                        return `${item.label}: solicitado ${item.Cantidad}, disponible ${loteSeleccionado.Cantidad} en el lote ${loteSeleccionado.Codigo}`;
                    });
                    notificarError(`Stock insuficiente en los lotes seleccionados:\n${mensajesError.join('\n')}`);
                    return;
                }
            }

            const itemsToDelete = items.filter(item => !!item.Correlativo);
            if (itemsToDelete.length > 0) {
                await Promise.all(itemsToDelete.map(item => deleteItem(item, false)));
            }

            if (items.length > 0) {
                const itemsToSave = items.filter(item => item.Cantidad > 0);

                for (const item of itemsToSave) {
                    await saveItem(item);
                }
            }

            await loadItems(tiposTransaccion);

            notificarMsg('Cambios guardados correctamente');
        } catch (error) {
            console.error('Error al guardar cambios:', error);
            notificarError('Error al guardar los cambios');
        }

        onActualizacionCompletada();
        onClose();
    }

    if (loading) {
        return (
            <div className="container-fluid d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Cargando...</span>
                </div>
            </div>
        );
    }

    return <div className="container-fluid" style={{ width: '100%' }}>
        <hr className="border-0" width="1024px" />

        <nav>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
                <button className="nav-link" id="nav-info-tab" data-toggle="tab" data-target="#nav-info" type="button" role="tab" aria-controls="nav-info" aria-selected="true">Datos de movimiento</button>
                <button className="nav-link active" id="nav-items-tab" data-toggle="tab" data-target="#nav-items" type="button" role="tab" aria-controls="nav-items" aria-selected="false">Items</button>
            </div>
        </nav>

        <div className="tab-content" id="nav-tabContent">
            <div className="tab-pane fade" id="nav-info" role="tabpanel" aria-labelledby="nav-info-tab">
                <div className="row">
                    <div className="col-12">
                        <div className="form-row">
                            <div className="form-group col-12">
                                <label htmlFor="IdTipoTransaccionAlmacen"><strong>Proveedor</strong></label>
                                <input
                                    type="text"
                                    className="form-control w-100"
                                    value={proveedor.NombreComercial}
                                    disabled
                                />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group col-12">
                                <label htmlFor="FechaMovimiento"><strong>Fecha Movimiento</strong></label>
                                <input
                                    type="text"
                                    value={moment(datosMovimiento.FechaMovimiento).format("YYYY-MM-DD")}
                                    className="form-control w-100"
                                    disabled
                                />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group col-12">
                                <label htmlFor="FechaMovimiento"><strong>Total</strong></label>
                                <input
                                    type="text"
                                    value={`S/ ${datosMovimiento.Total}`}
                                    className="form-control w-100"
                                    disabled
                                />
                            </div>
                        </div>

                        {
                            datosMovimiento.Glosa && (
                                <div className="form-row">
                                    <div className="form-group col-12">
                                        <label htmlFor="Glosa"><strong>Glosa</strong></label>
                                        <textarea
                                            className="form-control w-100"
                                            rows="3"
                                            value={datosMovimiento.Glosa || ''}
                                            disabled
                                        />
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>

                <div className="d-flex justify-content-end">
                    <button type="button" className="btn btn-secondary">Cerrar</button>
                </div>
            </div>
            <div className="tab-pane fade show active" id="nav-items" role="tabpanel" aria-labelledby="nav-items-tab">
                <div className="row mb-3">
                    <div className="col-12">
                        <ProductFinder onChoose={handleChooseProduct} tiposTransaccion={tiposTransaccion} />
                    </div>
                </div>

                <div className="row" style={{ minHeight: '300px' }}>
                    <div className="col-12">
                        <SalidaTable
                            sucursal={sucursal}
                            data={items}
                            tiposTransaccion={tiposTransaccion}
                            handleValueChange={handleValueChange}
                            handleDelete={handleDelete}
                        />
                    </div>
                </div>

                <div className="d-flex justify-content-between mt-3">
                    <button type="button" className="btn btn-secondary" onClick={onClose}>Cerrar</button>
                    <button 
                        type="button" 
                        className={`btn ${botonBloqueado ? 'btn-secondary' : 'btn-info'}`}
                        onClick={handleGuardarCambios}
                        disabled={botonBloqueado}
                    >
                        Guardar cambios
                    </button>
                </div>
            </div>
        </div>
    </div>
}